export default __webpack_public_path__ + "static/media/updatestwo.5b3820b5.svg";